/**
 * Created by Karol Kluska on 10.11.17.
 */

angular
  .module('app')
  .component('paymentStatus', {
    templateUrl: 'app/components/paymentStatus/PaymentStatus.html',
    controller: PaymentStatus
  });

/** @ngInject */
// eslint-disable-next-line
function PaymentStatus($rootScope, Params, Restangular, PAYMENT_STATUSES, $interval, $sce, $state, $translate) {
  var $this = this;
  $this.$rootScope = $rootScope;
  $this.Params = Params;
  $this.Restangular = Restangular;
  $this.PAYMENT_STATUSES = PAYMENT_STATUSES;
  $this.$interval = $interval;
  $this.$sce = $sce;
  $this.$state = $state;
  $this.$translate = $translate;
}

PaymentStatus.prototype = {
  $onInit: function () {
    var REFRESH_TIME = 10;
    var $this = this;
    $this.userHash = this.Params.getUserHash();
    $this.hotelId = this.Params.getHotelId();
    $this.language = this.Params.getLanguage();
    $this.paymentToken = this.Params.getPaymentToken();
    $this.getPaymentStatus();
    $this.isRefreshing = true;
    $this.refreshCountdownSeconds = REFRESH_TIME;
    $this.refreshCountdown = $this.$interval(function () {
      if ($this.refreshCountdownSeconds > 0) {
        $this.refreshCountdownSeconds--;
      }
    }, 1000);
    $this.refreshStatus = $this.$interval(function () {
      $this.refreshCountdownSeconds = REFRESH_TIME;
      $this.getPaymentStatus();
    }, REFRESH_TIME * 1000);
  },

  stopRefreshStatus: function () {
    this.isRefreshing = false;
    this.$interval.cancel(this.refreshStatus);
    this.$interval.cancel(this.refreshCountdown);
  },

  getStatus: function () {
    switch (this.payment.status) {
      case this.PAYMENT_STATUSES.NEW:
        return this.$sce.trustAsHtml(
          '<span style="color: #597eaa">' + this.$translate.instant('payment_status.statuses.NEW') + '</span>'
        );
      case this.PAYMENT_STATUSES.PENDING:
        return this.$sce.trustAsHtml(
          '<span style="color: #cf7431">' + this.$translate.instant('payment_status.statuses.PENDING') + '</span>'
        );
      case this.PAYMENT_STATUSES.OFFLINE:
        this.stopRefreshStatus();
        return this.$sce.trustAsHtml(
          '<span style="color: #cf7431">' + this.$translate.instant('payment_status.statuses.OFFLINE') + '</span>'
        );
      case this.PAYMENT_STATUSES.CANCELED:
        this.stopRefreshStatus();
        return this.$sce.trustAsHtml(
          '<span style="color: #cf2a27">' + this.$translate.instant('payment_status.statuses.CANCELED') + '</span>'
        );
      case this.PAYMENT_STATUSES.FAILED:
        this.stopRefreshStatus();
        return this.$sce.trustAsHtml(
          '<span style="color: #cf2a27">' + this.$translate.instant('payment_status.statuses.FAILED') + '</span>'
        );
      case this.PAYMENT_STATUSES.COMPLETED:
        this.stopRefreshStatus();
        return this.$sce.trustAsHtml(
          '<span style="color: #009e0f">' + this.$translate.instant('payment_status.statuses.COMPLETED') + '</span>'
        );
      case this.PAYMENT_STATUSES.AUTHORIZED:
        this.stopRefreshStatus();
        return this.$sce.trustAsHtml(
          '<span style="color: #009e0f">' + this.$translate.instant('payment_status.statuses.AUTHORIZED') + '</span>'
        );
      default:
        return this.$sce.trustAsHtml(
          '<span>' + this.$translate.instant('payment_status.statuses.UNKNOWN') + '</span>'
        );
    }
  },

  getMessageTitle: function () {
    if (angular.isDefined(this.message)) {
      return this.$sce.trustAsHtml(this.message.title || '');
    }
    return '';
  },

  getMessageContent: function () {
    if (angular.isDefined(this.message)) {
      return this.$sce.trustAsHtml(this.message.content || '');
    }
    return '';
  },

  getPaymentStatus: function () {
    var $this = this;
    $this.$rootScope.$emit('startLoading', {
      title: this.$translate.instant('loader.PLEASE_WAIT'),
      description: this.$translate.instant('loader.STATUS')
    });
    $this.Restangular.one('payments/' + this.paymentToken + '/status').get()
      .then(function (response) {
        $this.payment = response.payment;
        $this.message = response.template;
      })
      .catch(function () {
        $this.stopRefreshStatus();
        $this.$state.go('booking.clientErrors', {}, {location: false});
      })
      .finally(function () {
        $this.$rootScope.$emit('stopLoading');
      });
  }
};
